<template>
  <section class="section cat-section" id="category">
    <div class="section-title">
      {{ $t('category.sectionTitle') }}
    </div>
    <div class="cat-grid">
      <button
        type="button"
        class="cat-tile"
        :class="{ 'cat-tile--active': value === '1' }"
        @click="pick('1')"
      >
        <div class="cat-tile-img-wrap">
          <img :src="require('@/assets/product1-1.png')" :alt="$t('category.power').replace(/\n/g, ' ')" class="cat-tile-img1">
        </div>
        <div class="cat-tile-footer">
          <div class="cat-tile-name" v-html="$t('category.power').replace(/\n/g, '<br>')"></div>
          <div class="cat-tile-line-wrap">
            <div class="cat-tile-line" aria-hidden="true" />
            <div class="cat-tile-line-gary" aria-hidden="true" />
          </div>
        </div>
      </button>
      <button
        type="button"
        class="cat-tile"
        :class="{ 'cat-tile--active': value === '2' }"
        @click="pick('2')"
      >
        <div class="cat-tile-img-wrap">
          <img :src="require('@/assets/product1-2.png')" alt="SMART WEARABLES" class="cat-tile-img2">
        </div>
        <div class="cat-tile-footer">
          <div class="cat-tile-name" v-html="$t('category.wearables').replace(/\n/g, '<br>')"></div>
          <div class="cat-tile-line-wrap">
            <div class="cat-tile-line" aria-hidden="true" />
            <div class="cat-tile-line-gary" aria-hidden="true" />
          </div>
        </div>
      </button>
      <button
        type="button"
        class="cat-tile"
        :class="{ 'cat-tile--active': value === '3' }"
        @click="pick('3')"
      >
        <div class="cat-tile-img-wrap">
          <img :src="require('@/assets/product1-3.png')" alt="TWS" class="cat-tile-img3">
        </div>
        <div class="cat-tile-footer">
          <div class="cat-tile-name">{{ $t('category.tws') }}</div>
          <div class="cat-tile-line-wrap">
            <div class="cat-tile-line" aria-hidden="true" />
            <div class="cat-tile-line-gary" aria-hidden="true" />
          </div>
        </div>
      </button>
      <button
        type="button"
        class="cat-tile"
        :class="{ 'cat-tile--active': value === '4' }"
        @click="pick('4')"
      >
        <div class="cat-tile-img-wrap">
          <img :src="require('@/assets/product1-4.png')" alt="BLUETOOTH SPEAKER" class="cat-tile-img4">
        </div>
        <div class="cat-tile-footer">
          <div class="cat-tile-name" v-html="$t('category.speaker').replace(/\n/g, '<br>')"></div>
          <div class="cat-tile-line-wrap">
            <div class="cat-tile-line" aria-hidden="true" />
            <div class="cat-tile-line-gary" aria-hidden="true" />
          </div>
        </div>
      </button>
      <button
        type="button"
        class="cat-tile"
        :class="{ 'cat-tile--active': value === '5' }"
        @click="pick('5')"
      >
        <div class="cat-tile-img-wrap">
          <img :src="require('@/assets/product1-5.png')" alt="OTHERS" class="cat-tile-img5">
        </div>
        <div class="cat-tile-footer">
          <div class="cat-tile-name">{{ $t('category.others') }}</div>
          <div class="cat-tile-line-wrap">
            <div class="cat-tile-line" aria-hidden="true" />
            <div class="cat-tile-line-gary" aria-hidden="true" />
          </div>
        </div>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductCategorySection',
  props: {
    value: {
      type: String,
      default: '',
    },
    /** 为 true 时点击分类会跳转到产品中心并带上 ?cat= */
    navigateOnClick: {
      type: Boolean,
      default: false,
    },
    /**
     * 为 true 时（如产品中心页）：点击后滚动到 id 为 `anchorIdPrefix + id` 的元素（hash 路由下不用 href 锚点，避免与 #/ 冲突）
     */
    anchorScroll: {
      type: Boolean,
      default: false,
    },
    anchorIdPrefix: {
      type: String,
      default: 'pc-cat-',
    },
  },
  methods: {
    pick(id) {
      this.$emit('input', id)
      if (this.navigateOnClick) {
        this.$router.push({
          name: 'productCenter',
          query: { cat: id },
        })
      }
      if (this.anchorScroll) {
        this.$nextTick(() => {
          const el = document.getElementById(`${this.anchorIdPrefix}${id}`)
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        })
      }
    },
  },
}
</script>

<style scoped>
.section {
  padding: 36px 24px 0;
}

.section-title {
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 38px;
  color: #282828;
  line-height: 33px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.cat-section {
  background: #EDEDED;
  margin: 78px auto 0;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 8px;
}

.cat-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
  max-width: 1570px;
  height: 300px;
  margin: 64px auto 0;
}

.cat-tile {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  background: #fff;
  text-align: left;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;
}

.cat-tile:hover,
.cat-tile:focus-visible {
  background: #2563eb;
  box-shadow: 0 2px 12px rgba(37, 99, 235, 0.35);
  outline: none;
}

.cat-tile:focus-visible {
  box-shadow: 0 2px 12px rgba(37, 99, 235, 0.45), 0 0 0 2px #fff, 0 0 0 4px #2563eb;
}



.cat-tile-img-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 14px 8px;
  min-height: 132px;
  overflow: hidden;
}

.cat-tile-img1 {
  max-width: 74%;
  max-height: 100%;
}
.cat-tile-img2 {
  max-width: 53%;
  max-height: 100%;
}
.cat-tile-img3 {
  max-width: 46%;
  max-height: 100%;
}
.cat-tile-img4 {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  object-fit: cover;
}
.cat-tile-img5 {
  max-width: 62%;
  max-height: 100%;
}
.cat-tile-img1,
.cat-tile-img2,
.cat-tile-img3,
.cat-tile-img4,
.cat-tile-img5 {
  transition: transform 0.35s ease, filter 0.35s ease;
}
.cat-tile:hover .cat-tile-img1,
.cat-tile:hover .cat-tile-img2,
.cat-tile:hover .cat-tile-img3,
.cat-tile:hover .cat-tile-img4,
.cat-tile:hover .cat-tile-img5 {
  transform: scale(1.06);
  filter: brightness(1.06);
}
.cat-tile-footer {
  padding: 10px 45px 16px;
}

.cat-tile-name {
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 22px;
  color: #454545;
  line-height: 26px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.cat-tile-line {
  width: 33%;
  max-width: 96px;
  height: 4px;
  margin-top: 10px;
  border-radius: 1px;
  background: #2563eb;
  z-index: 2;
}
.cat-tile-line-gary{
  width: 63%;
  height: 4px;
  margin-top: 10px;
  border-radius: 1px;
  background: #EDEDED;
  position: relative;
  z-index: 0;
  left: -1px;
}
.cat-tile-line-wrap{
  display: flex;
}

.cat-tile:hover .cat-tile-name,
.cat-tile:focus-visible .cat-tile-name {
  color: #fff;
}

.cat-tile:hover .cat-tile-line,
.cat-tile:focus-visible .cat-tile-line,
.cat-tile:hover .cat-tile-line-gary,
.cat-tile:focus-visible .cat-tile-line-gary {
  background: #fff;
}

@media (max-width: 960px) {
  .cat-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .cat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .cat-tile-img-wrap {
    min-height: 100px;
    padding: 12px 10px 6px;
  }

  .cat-tile-name {
    font-size: 10px;
  }
}
</style>
